(function () {
  'use strict';
  var cards = document.querySelectorAll('.tg-etc__item');
  var activeCard = null;

  cards.forEach(function (card) {
    card.addEventListener('click', function (e) {
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

      // Tapping the CTA button inside an already-open panel navigates normally.
      if (e.target.closest('.tg-etc__panel-cta')) return;

      // A single tap anywhere else on the card just opens its panel — the
      // card itself never navigates on tap; only the CTA button does.
      e.preventDefault();
      if (activeCard && activeCard !== card) activeCard.classList.remove('is-active');
      card.classList.add('is-active');
      activeCard = card;
    });
  });
})();
